import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
export function Layout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="min-h-screen bg-cream font-body selection:bg-golden selection:text-jet flex flex-col" data-id="element-221">
      <Navbar data-id="element-222" />
      <main className="flex-grow" data-id="element-223">
        <Outlet data-id="element-224" />
      </main>
      <Footer data-id="element-225" />
    </div>;
}